<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader>
						Gestion des vols

						<div class="card-header-actions">
							<CButton color="primary" v-on:click="showAddModal()"> + Ajouter </CButton>
						</div>
					</CCardHeader>

					<CCardBody>
						<GDataTableRemote
							ref="mainTable"
							remote-url="/api/flights"
							:fields="fields"
							:items-per-page="10"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<!-- TODO: Handle state
                            <template #state="{item}">
                              <td>
                                <CBadge :color="stateColors[item.state]" >{{ item.translatedState }}</CBadge>
                              </td>
                            </template>
                            -->

							<template #LTA="{ item }">
								<td>
									<router-link :to="`/aerial/pallets?flight=${item.id}`">
										{{ item.LTA }}
									</router-link>
								</td>
							</template>

							<template #actions="{ item }">
								<td class="text-center">
									<router-link
										class="icon-action"
										:to="`/aerial/pallets?flight=${item.id}`">
										<CIcon name="cil-layers" />
									</router-link>
									<a class="icon-action" href="#" @click.prevent="showEditModal(item)">
										<CIcon name="cil-pencil" />
									</a>
									<a class="icon-action" href="#" @click.prevent="showDeleteNotify(item)">
										<CIcon name="cil-trash" />
									</a>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>

		<AddModal ref="addModal" v-on:refresh="refresh()" />
		<ModifyModal ref="modifyModal" v-on:refresh="refresh()" />
	</div>
</template>
<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';
	import AddModal from './AddFlight';
	import ModifyModal from './ModifyFlight';

	export default {
		components: {
			GDataTableRemote,
			AddModal,
			ModifyModal,
		},

		data() {
			const states = [
				{ value: 'flight.pending', label: 'En attente' },
				{ value: 'flight.filling_in_progress', label: 'Remplissage en cours' },
				{ value: 'flight.filled', label: 'Rempli' },
				{ value: 'flight.took_off', label: 'A décollé' },
				{ value: 'flight.landed', label: 'A atteri' },
			];
			return {
				fields: [
					{ key: 'LTA', label: 'LTA' },
					{ key: 'reference', label: 'N°Vol' },
					// { key: 'state', label: 'Statut', type: 'select', filterSelectOptions: states },
					{ key: 'handoverTime', label: 'Date de remise', type: 'datetime' },
					{ key: 'arrivalAirport.name', label: 'Destination' },
					{ key: 'arrivalTime', label: "Date d'arrivée", type: 'datetime' },
					{ key: 'weightLimit', label: 'Limite poids' },
					{ key: 'volumeLimit', label: 'Limite volume' },
					{ key: 'quantityLimit', label: 'Limite quantité' },
					{ key: 'actions', filter: false },
				],
				activePage: 1,
				stateColors: {
					'flight.pending': 'info',
					'flight.filling_in_progress': 'warning',
					'flight.filled': 'success',
					'flight.took_off': 'warning',
					'flight.landed': 'success',
				},
			};
		},

		methods: {
			showAddModal: function () {
				this.$refs.addModal.showModal = true;
			},
			showEditModal: function ($flight) {
				this.$refs.modifyModal.flight = $flight;
				this.$refs.modifyModal.showModal = true;
			},
			showDeleteNotify: function (item) {
				if (
					confirm('Est-ce que vous êtes sûr de vouloir supprimer ce vol et toutes ses palettes ?')
				) {
					this.$axios.delete(`/api/flights/${item.id}`).then(res => {
						this.$toast.success(`Le vol ${item.reference} a bien été supprimé`);
						this.$refs.mainTable.refresh();
					});
				}
			},
			refresh: function () {
				this.$refs.mainTable.refresh();
			},
		},
	};
</script>
<style>
	.icon-action {
		margin-right: 5px;
	}
	.icon-action:last-child {
		margin-right: 0px;
	}
	.badge-warning {
		color: white;
	}
</style>
